export class Point {
  constructor(props:any) { Object.assign(this, props) }
  public earned: number =  0
  public used: number = 0
  public balance: number = 0
}
